(() => {
  if (window.MaxnewSizeUnits) return;

  // Measurement semantics are marked by Liquid; translated labels never determine conversion.
  const numberPattern = /^\d+(?:[.,]\d+)?(?:\s*[–—-]\s*\d+(?:[.,]\d+)?)?$/;
  function enhance(root = document) {
    const regions = [...root.querySelectorAll('.mx-facts-table[data-mx-base-unit="cm"]')];
    if (root.matches?.('.mx-facts-table[data-mx-base-unit="cm"]')) regions.unshift(root);
    regions.forEach((region) => {
      if (region.dataset.unitsReady) return;
      const table = region.querySelector('table');
      if (!table) return;
      const columns = [...table.querySelectorAll('thead th')].map((header) => header.dataset.mxMeasure === 'length');
      const cells = [...table.querySelectorAll('tbody tr')].flatMap((row) => [...row.children]
        .filter((cell, index) => columns[index])
        .map((cell) => ({ cell, original: cell.dataset.mxBaseValue || cell.textContent.trim() }))
        .filter(({ original }) => numberPattern.test(original)));
      if (!cells.length) return;
      cells.forEach(({ cell, original }) => { cell.dataset.mxBaseValue = original; cell.textContent = original; });
      region.dataset.unitsReady = 'true';
      const initialCaptionUnit = table.querySelector('[data-mx-chart-unit]');
      if (initialCaptionUnit) initialCaptionUnit.textContent = '(cm)';
      const control = document.createElement('div');
      control.className = 'mx-size-units';
      control.setAttribute('role', 'group');
      control.setAttribute('aria-label', region.dataset.mxUnitsLabel || 'cm / in');
      let formatter;
      try { formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', { minimumFractionDigits: 1, maximumFractionDigits: 1 }); }
      catch { formatter = new Intl.NumberFormat('en', { minimumFractionDigits: 1, maximumFractionDigits: 1 }); }
      const buttons = ['cm', 'in'].map((unit) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = unit;
        button.setAttribute('aria-pressed', String(unit === 'cm'));
        button.addEventListener('click', () => {
          cells.forEach(({ cell, original }) => {
            cell.textContent = unit === 'cm' ? original : original.split(/([–—-])/).map((part) => /[–—-]/.test(part) ? part : formatter.format(Number(part.trim().replace(',', '.')) / 2.54)).join('');
          });
          const captionUnit = table.querySelector('[data-mx-chart-unit]');
          if (captionUnit) captionUnit.textContent = `(${unit})`;
          buttons.forEach((other) => other.setAttribute('aria-pressed', String(other === button)));
        });
        control.append(button);
        return button;
      });
      region.before(control);
    });
  }
  window.MaxnewSizeUnits = { enhance };
  enhance();
  document.addEventListener('DOMContentLoaded', () => enhance());
  document.addEventListener('shopify:section:load', (event) => enhance(event.target));
})();
